import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";
import { useLocation } from "react-router";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_helpers";
import { Divider } from "@material-ui/core";
import { isAgente } from "../../../../../app/config/config";
import { useIsMobile } from '../../../../../app/useIsMobile'
import { KTLayoutAside } from '../../../../_assets/js/layout/base/aside'
import getMenuConfig from "./menuConfig";

export function AsideMenuList({ layoutProps }) {
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const userIsAgente = isAgente(parseInt(user.idRole));
  const role = parseInt(user.idRole);
  const location = useLocation();
  const isMobile = useIsMobile();

  // Funzione per chiudere il menu sui dispositivi mobili
  const closeMobileMenu = () => {
    if (isMobile) {
      // Utilizza il sistema offcanvas di Metronic per chiudere il menu
      const offcanvas = KTLayoutAside.getOffcanvas()
      if (offcanvas) {
        offcanvas.hide()
      }
    }
  }

  function checkIsActive(location, url) {
    const currentPath = location.pathname;
    const currentHash = location.hash;
    const currentUrl = `${currentPath}${currentHash}`;

    if (!currentUrl || !url) {
      return false;
    }

    // Match esatto
    if (currentUrl === url) {
      return true;
    }

    // Match parziale solo per gli elementi terminali (non submenu)
    if (currentUrl.includes(url) && !currentUrl.includes('#')) {
      return true;
    }

    return false;
  }


  const NiceDivider = () => (
    <Divider style={{ backgroundColor: 'rgba(0, 0, 0, 0.12)' }} />    
  );

  // Funzione per verificare se un elemento è attivo
  const getMenuItemActive = (url, isSubmenu = false, urls = []) => {
    const isActive = checkIsActive(location, url) || urls.some((u) => checkIsActive(location, u));

    if (isSubmenu) {
      return isActive ? "menu-item-open" : "";
    }
    return isActive ? "menu-item-active" : "";
  };

  // Voce singola di menu
  const MenuItem = ({ item }) => {
    const allowedRoles = item.allowedRoles || [];
    if (!allowedRoles.length || allowedRoles.includes(role) || item.allowedRoles.includes(true)) {
      return (
        <li className={`menu-item ${getMenuItemActive(item.url, false)}`} aria-haspopup="true" key={item.url}>
          {item.openInNewWindow ? (
            <a className="menu-link" href={item.url} target="_blank" rel="noopener noreferrer" onClick={closeMobileMenu}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl(item.icon)} />
              </span>
              <span className="menu-text">{item.title}</span>
            </a>
          ) : (
            <NavLink className="menu-link" to={item.url} onClick={closeMobileMenu}>
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl(item.icon)} />
              </span>
              <span className="menu-text">{item.title}</span>
            </NavLink>
          )}
        </li>
      );
    }
    return null;
  };

  // Sottomenu
  const SubMenu = ({ item }) => {
    const subItems = item.items.filter(
      (subItem) => {
        const allowedRoles = subItem.allowedRoles || [];
        return !allowedRoles.length || allowedRoles.includes(role) || allowedRoles.includes(true);
      }
    );

    const activeUrls = subItems.map((sub) => sub.url);
    const isOpen = getMenuItemActive(item.url, true, activeUrls);

    return (
      <li
        className={`menu-item menu-item-submenu ${isOpen}`}
        aria-haspopup="true"
        data-menu-toggle="hover"
        key={item.url}
      >
        <span className="menu-link menu-toggle">
          <span className="svg-icon menu-icon">
            <SVG src={toAbsoluteUrl(item.icon)} />
          </span>
          <span className="menu-text">{item.title}</span>
          <i className="menu-arrow" />
        </span>
        <div className="menu-submenu">
          <ul className="menu-subnav">
            <li className="menu-item menu-item-parent" aria-haspopup="true">
              <span className="menu-link">
                <span className="menu-text">{item.title}</span>
              </span>
            </li>
            {subItems.map((subItem) => (
              <MenuItem item={subItem} key={subItem.url} />
            ))}
          </ul>
        </div>
      </li>
    );
  };

  const menuConfig = getMenuConfig(userIsAgente, user);

  // Filtra i menu in base al ruolo dell'utente
  const filteredMenu = menuConfig.filter(
    (item) => !item.allowedRoles || item.allowedRoles.includes(role) || item.allowedRoles.includes(true)
  );

  return (
    <ul className={`menu-nav ${layoutProps.ulClasses}`}>
      {filteredMenu.map((item, index) => {
        if (item.type === "submenu") {
          return (
            <React.Fragment key={`submenu-group-${index}`}>
              <SubMenu item={item} />
              <NiceDivider />
            </React.Fragment>
          );
        } else {
          return <MenuItem item={item} key={`menuitem-${item.url || index}`} />;
        }
      })}
    </ul>
  );
}
